import React from 'react';
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const ManualEditPage = () => {
  return (
    <div>
      <SEO
        title="Manual Script Editor"
        description="Manually edit and fine-tune your film script with ProducerBuddy's script editing tools."
        url="https://producerbuddy.pilomation.com/manual-edit"
        robots="noindex, nofollow"
      />
      <h1>Manual Editor</h1>
      <p>This is where the manual editing functionality will go.</p>
    </div>
  );
};

export default ManualEditPage;

